import React, { useState } from 'react';
import Navbar from './components/Navbar';
import MainContent from './components/MainContent';
import AboutSection from './components/AboutSection';
import CasesSection from './components/CasesSection';
import ContactSection from './components/ContactSection';


function App() {
  const userName = "Joshua Silva";
  const yearValue = "2025";
  const [currentSection, setCurrentSection] = useState('home');
  
  const handleNavigate = (section: string) => {
    setCurrentSection(section);
  };
  
  const renderContent = () => {
    switch (currentSection) {
      case 'home':
        return <MainContent name={userName} year={yearValue} onNavigate={handleNavigate} />;
      case 'projects':
        return <CasesSection />;
      case 'about':
        return <AboutSection name={userName} year={yearValue} />;
      case 'contact':
        return <ContactSection />;
      default:
        return <MainContent name={userName} year={yearValue} onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="app-container">
      {/* Navigation */}
      <Navbar onSectionChange={setCurrentSection} />

      {/* Dynamic Content */}
      {renderContent()}
    </div>
  );
}

export default App;
